
<template>
    <v-container class="" fluid>
        <v-row no-gutters class="">

            <div class=" !w-full !px-5 bg-black h-[calc(100vh-150px)] overflow-scroll  rounded-2xl">
                <div class="">
                    <v-card-title class="justify-center py-6 text-center">
                        <h4 :class="`${routeLink}_fortext !text-2xl font-Handel `">
                            Subscription Details
                        </h4>
                    </v-card-title>
                </div>
                <SubscriptionListUi />

            </div>
        </v-row>
    </v-container>
</template>
<script>
import SubscriptionListUi from './SubscriptionListUi.vue';

export default {
    components: { SubscriptionListUi },
    data() {
        return {
            
        }
    },
}
</script>